import { ReactNode } from 'react';
import { DialogTitle, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface ColoredDialogTitleProps {
  children: ReactNode;
  onClose: () => void;
}

function ColoredDialogTitle({ children, onClose }: ColoredDialogTitleProps) {
  return (
    <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1.75, px: 3, backgroundColor: 'primary.main' }}>
      <Typography variant="subtitle1" fontWeight={600} sx={{ color: 'common.white', fontSize: '0.95rem' }}>
        {children}
      </Typography>
      <IconButton size="small" onClick={onClose} sx={{ color: 'common.white', opacity: 0.85, '&:hover': { opacity: 1 } }}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </DialogTitle>
  );
}

export default ColoredDialogTitle;
